module.exports = __webpack_public_path__ + "static/media/uniform-web-logo.825e6c57.png";